(function () {
  if (window.__herbionRetailerTrackingBound) return;
  window.__herbionRetailerTrackingBound = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-herbion-retailer-link]');
    if (!link) return;

    var payload = {
      retailer: link.dataset.retailer || 'Amazon Canada',
      retailer_position: Number(link.dataset.retailerPosition || 1),
      product_id: link.dataset.productId || '',
      product_name: link.dataset.productTitle || '',
      product_handle: link.dataset.productHandle || '',
      destination_url: link.href,
      page_path: window.location.pathname
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'retailer_click' }, payload));

    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'RetailerClick', {
        retailer: payload.retailer,
        retailer_position: payload.retailer_position,
        product_name: payload.product_name,
        product_handle: payload.product_handle,
        destination_url: payload.destination_url
      });
    }

    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      try {
        var published = Shopify.analytics.publish('herbion:retailer_click', payload);
        if (published && typeof published.catch === 'function') {
          published.catch(function () {});
        }
      } catch (e) {}
    }
  });
})();